<template>
  <Layout>
    <div class="dimished-wrapper">
      <div class="diminished-inner flex-1-3 mb-5">
        <q-card square class="dimished-value-calculator align-self">
          <div class="dimished-title">
            <div>Diminished Value Calculate</div>
          </div>
          <DimishedValueCalculate />
        </q-card>
        <q-card square class="align-self">
          <DimishedCalculateResult />
        </q-card>
      </div>
      <q-card square class="dimished-value-calculator align-self flex-2-3">
        <div class="dimished-title">
          <div>Diminished Value Standard Formula</div>
        </div>
        <DimishedValueDescription />
      </q-card>
    </div>
  </Layout>
</template>

<script>
import DimishedValueDescription from "../components/DimishedValueDescription";
import DimishedValueCalculate from "../components/DimishedValueCalculate";
import DimishedCalculateResult from "../components/DimishedCalculateResult";
import Layout from "../components/Layout";
export default {
  components: {
    DimishedCalculateResult,
    DimishedValueCalculate,
    DimishedValueDescription,
    Layout,
  },
  metaInfo() {
    return {
      title: "Diminished Value Calculator | FMS",
      meta: [
        {
          name: "description",
          content: "Diminished Value Calculator",
        },
        {
          property: "og:title",
          content: "Diminished Value Calculator | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  computed: {
    show: {
      set(val) {
        this.$store.commit("dimishedValue/SET_SHOW", val);
      },
      get() {
        return this.$store.state.dimishedValue.show;
      },
    },
  },
};
</script>


<style lang="scss">
@media only screen and (min-width: 1080px) and (max-width: 1440px) {
  .dimished-wrapper {
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
  }
  .flex-1-3,
  .flex-2-3 {
    margin: 0px 10px;
    flex: 0 1 calc(50% - 10px);
  }
}

@media only screen and (min-width: 1441px) {
  .dimished-wrapper {
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
  }
  .flex-1-3 {
    margin: 0px 5px;
    flex: 0 1 calc(39% - 10px);
  }
  .flex-2-3 {
    margin: 0px 5px;
    flex: 0 1 calc(60% - 10px);
  }
}

@media only screen and (max-width: 1079px) {
  .dimished-wrapper {
    flex: 1;
    display: flex;
    flex-flow: column nowrap;
    .f-f {
      margin: 10px;
      flex: 1;
    }
  }
}

.align-self {
  align-self: flex-start;
}
.dimished-value-calculator {
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  .dimished-title {
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
    font-weight: 700;
    color: #000;
    font-size: 20px;
    padding: 15px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    div {
      text-align: center;
      flex: 1;
    }
  }
  .step {
    padding: 5px 15px;
  }
  .inner-step {
    &:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>